import {KeysetQuery, translation} from "@2d-front-monorepo/core";
import {
	ErrorMessage,
	Message,
	RemoteDataStatus,
	TabPanel,
	Tabs,
	useRemoteData
} from "@2d-front-monorepo/design-library";
import {PermitTranslations} from "@2d-front-monorepo/shared-translations";
import {JSX, useState} from "react";
import PermitsInlineLoading from "../../components/PermitsInlineLoading";
import {getHttpClient} from "../../hooks/getHttpClient";
import PermitInvoices from "./PermitInvoices";
import ReservationInvoices from "./ReservationInvoices";

export default function Invoices(): JSX.Element {
	const [permitsQuery, setPermitsQuery] = useState<KeysetQuery<number>>({});
	const [reservationsQuery, setReservationsQuery] = useState<KeysetQuery<number>>({});

	const permits = useRemoteData(signal => getHttpClient().permits.listPayments(permitsQuery, signal), [permitsQuery]);
	const reservations = useRemoteData(signal => getHttpClient().reservations.listPayments(reservationsQuery, signal), [reservationsQuery]);

	const title = <h1>{translation(PermitTranslations.invoices_page__title)}</h1>;

	if ((permits.status === RemoteDataStatus.Loading && permits.data == null)
		|| (reservations.status === RemoteDataStatus.Loading && reservations.data == null)) {
		return <>{title}<PermitsInlineLoading/></>;
	}

	if (permits.status === RemoteDataStatus.Error) {
		return <>{title}<ErrorMessage error={permits.error}/></>;
	}

	if (reservations.status === RemoteDataStatus.Error) {
		return <>{title}<ErrorMessage error={reservations.error}/></>;
	}

	const hasPermitInvoices = permits.data!.data.length > 0;
	const hasReservationInvoices = reservations.data!.data.length > 0;

	if (!hasPermitInvoices && !hasReservationInvoices) {
		return (
			<>
				{title}
				<Message title={{text: translation(PermitTranslations.invoices_page__no_invoices)}} type="information"/>
			</>
		);
	}

	return (
		<>
			{title}
			<Tabs>
				<TabPanel title={translation(PermitTranslations.summary_page__permits)} hidden={!hasPermitInvoices}>
					<PermitInvoices
						data={permits.data!}
						loading={permits.status === RemoteDataStatus.Loading}
						onPageChange={setPermitsQuery}/>
				</TabPanel>
				<TabPanel title={translation(PermitTranslations.summary_page__reservations)} hidden={!hasReservationInvoices}>
					<ReservationInvoices
						data={reservations.data!}
						loading={reservations.status === RemoteDataStatus.Loading}
						onPageChange={setReservationsQuery}/>
				</TabPanel>
			</Tabs>
		</>
	);
}
